var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-module"},[_c('div',{staticClass:"normal-name"},[_c('module-name',{attrs:{"name":_vm.name}})],1),_c('controler',{attrs:{"right":"-45px","visible":true,"move":false,"del":false},on:{"edit":_vm.edit,"moveUp":_vm.moveUp,"moveDown":_vm.moveDown,"remove":_vm.remove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }